<soft-dynamic-object
  [definition]="definition"
  [value]="value"
></soft-dynamic-object>
